<template>
  <div
    class="deal-wrap"
    v-html="dealText"
  >

  </div>
</template>
<script>
import axios from "../../http";
export default {
  name: "deal",
  components: {},
  props: {},
  data() {
    return {
        dealText: ""
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getDeal();
  },
  destroyed() {},
  methods: {
    getDeal() {
      axios.fetchPost("/api/app/user_agreement").then(res => {
        let data = res.data;
        if (data.code == 200) {
          this.dealText = data.data.content;
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.deal-wrap
  padding 20px 12px
  font-size 13px
  color rgba(40, 40, 40, 1)
  line-height 20px
  text-align left
  & > p
    font-size 13px
</style>